import { getProductScope } from '@discover-frontend/utils';
import { CAMPAIGN_STATUS } from 'src/modules/audience-activation/constants';
import { SelectedDestination } from 'src/modules/audience-activation/types';
import { callApi_v2 } from 'src/utils/api_v2';

export interface Destination {
  name: string;
  label: string;
}

interface DestinationsResponse {
  data: Array<Destination>;
  error: Error | null;
}

export const fetchDestinations = async (): Promise<DestinationsResponse> => {
  const response = await callApi_v2({
    api: 'WORKSPACE',
    method: 'GET',
    endpoint: '/destinations',
  });

  return response.data;
};

export const TARGET_MESSAGE_CODE = {
  AUDIENCE_NARROW: 'AUDIENCE_NARROW',
  NO_AUDIENCE_FOUND: 'NO_AUDIENCE_FOUND',
  AUDIENCE_WIDE: 'AUDIENCE_WIDE',
  SUCCESS: 'SUCCESS',
} as const;

interface TargetsResponse {
  targetCount: number;
  code: keyof typeof TARGET_MESSAGE_CODE;
  message: string;
}

export const fetchTargets = async (
  runId: string,
  scope: string
): Promise<TargetsResponse> => {
  const response = await callApi_v2({
    api: 'WORKSPACE',
    method: 'GET',
    endpoint: `/targets?run_id=${runId}&scope=${scope}`,
  });

  return response.data;
};

export interface CampaignPayload {
  campaignName: string;
  startDate: string;
  nodeId: string;
  endDate: string;
  additionalNotes: string;
  scope: string;
  status: typeof CAMPAIGN_STATUS[keyof typeof CAMPAIGN_STATUS];
  selectedDestinations: SelectedDestination[];
}

export const postCampaign = (body: CampaignPayload) =>
  callApi_v2({
    api: 'WORKSPACE',
    method: 'POST',
    endpoint: `/campaigns`,
    body,
  });

export const putCampaign = (campaignId: string, body: CampaignPayload) =>
  callApi_v2({
    api: 'WORKSPACE',
    method: 'PUT',
    endpoint: `/campaigns/${campaignId}`,
    body,
  });

export const deleteCampaign = (campaignId: string) =>
  callApi_v2({
    api: 'WORKSPACE',
    method: 'DELETE',
    endpoint: `/campaigns/${campaignId}?scope=${getProductScope()}`,
  });
